import React from 'react';

const DeliveredValue = () => {
  const values = [
    {
      title: "Enhanced Compliance",
      description: "100% of our projects achieve full regulatory compliance",
      metrics: [
        { label: "IEC 61511 Compliance", value: "100%" },
        { label: "Audit Success Rate", value: "100%" },
        { label: "Regulatory Approvals", value: "First Pass" }
      ],
      icon: "fas fa-certificate",
      image: "/assets/asset-24.jpg"
    },
    {
      title: "Reduced Maintenance Burden",
      description: "Streamlined processes that save time and resources",
      metrics: [
        { label: "Maintenance Time Reduction", value: "40%" },
        { label: "MTBF Improvement", value: "35%" },
        { label: "Cost Savings", value: "25-30%" }
      ],
      icon: "fas fa-tools",
      image: "/assets/asset-20.jpg"
    },
    {
      title: "Reliable Lifecycle Data Management",
      description: "Digital solutions that ensure data integrity and accessibility",
      metrics: [
        { label: "Data Accuracy", value: "99.9%" },
        { label: "Retrieval Speed", value: "< 30 sec" },
        { label: "System Uptime", value: "99.95%" }
      ],
      icon: "fas fa-database",
      image: "/assets/asset-21.jpg"
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Delivered Value</h2>
          <p className="text-xl text-gray-300">Measurable results that matter</p>
        </div>
        
        <div className="space-y-16">
          {values.map((value, index) => (
            <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <i className={`${value.icon} text-5xl text-blue-400 mb-6 block`}></i>
                <h3 className="text-3xl font-bold mb-4">{value.title}</h3>
                <p className="text-xl text-gray-300 mb-8">{value.description}</p>
                <div className="grid grid-cols-3 gap-4">
                  {value.metrics.map((metric, idx) => (
                    <div key={idx} className="text-center">
                      <div className="text-2xl font-bold text-blue-400">{metric.value}</div>
                      <div className="text-sm text-gray-400">{metric.label}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <img
                  src={value.image}
                  alt={value.title}
                  className="rounded-lg shadow-2xl"
                />
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-gray-800 p-12 rounded-lg text-center">
          <h3 className="text-3xl font-bold mb-6">Overall Impact</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="text-5xl font-bold text-blue-400 mb-2">$50M+</div>
              <p className="text-gray-300">Cost Savings Delivered</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-green-400 mb-2">Zero</div>
              <p className="text-gray-300">Safety Incidents</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-purple-400 mb-2">200%</div>
              <p className="text-gray-300">ROI Average</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-orange-400 mb-2">24/7</div>
              <p className="text-gray-300">System Reliability</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeliveredValue;
